<template>
    <div class="mt-70">
    <app-header></app-header>
    <v-container fluid grid-list-xl pa-0 mt-5>
      <v-layout row wrap justify-center align-center mt-5>
        <v-flex xs10 sm6 mt-5>
          <v-card-text class="text-xs-center">
            <div class="primary--text error-text text-xs-center">404</div>
            <div class="font-20 text-xs-center mt-4">{{$t("page404.pageNotFound")}}</div>
            <div class="font-18 text-xs-center mt-4 mb-4">{{$t("page404.hintMessage")}}</div>          
               <v-btn round flat outline large color="primary" @click="goHome">
                <b>{{$t("page404.homepageButton")}}</b>
              </v-btn>
          </v-card-text>
        </v-flex>
      </v-layout>
    </v-container>
    </div>
</template>
<style>
</style>
<script>
export default {
  methods: {
    goHome() {
      this.$router.push({ name: "home" });
      this.$router.go();
    }
  }
};
</script>


// WEBPACK FOOTER //
// Page404.vue?71bdd769